/**
 * Toolbox Talks Module Configuration
 *
 * Registered with `showInSidebar: false` because it is surfaced inside
 * the top-level `field-operations` sidebar container.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const toolboxTalksModule: AppModule = {
    id: 'toolbox-talks',

    navigation: {
        label: 'Toolbox Talks',
        icon: 'hard-hat',
        path: '/toolbox-talks',
        order: 79,
        showInSidebar: false,
        moduleKey: 'toolbox_talks',
        pages: [
            {
                label: 'All Talks',
                path: '/toolbox-talks',
                moduleKey: 'toolbox_talks',
            },
            {
                label: 'Generate with AI',
                path: '/toolbox-talks/generate',
                moduleKey: 'toolbox_talks',
                minAccessLevel: 'standard',
            },
            {
                label: 'Template Library',
                path: '/toolbox-talks/templates',
                moduleKey: 'toolbox_talks',
            },
            {
                label: 'Analytics',
                path: '/toolbox-talks/analytics',
                moduleKey: 'toolbox_talks',
            },
            {
                label: 'Compliance',
                path: '/toolbox-talks/compliance',
                moduleKey: 'toolbox_talks',
            },
            {
                label: 'Worker Badges',
                path: '/toolbox-talks/badges',
                moduleKey: 'toolbox_talks',
            },
            {
                label: 'Categories',
                path: '/toolbox-talks/categories',
                moduleKey: 'toolbox_talks',
                minAccessLevel: 'full',
            },
            {
                label: 'Settings',
                path: '/toolbox-talks/settings',
                moduleKey: 'toolbox_talks',
                minAccessLevel: 'full',
            },
        ],
    },

    routes,
}

export default toolboxTalksModule
